module.exports = __webpack_public_path__ + "img/steve-pro.a78c5f2e.jpg";